<template>
  <div id="point_report">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            {{ $t('ReportView.ProjectStats') }}
          </div>
          <div class="tip">
            {{ $t('ReportView.DownloadableMonthlyStats') }}
          </div>
        </div>
      </div>
      <filter-frame
        ref="filter"
        :save-filter="true"
        :filter-form="filterForm"
        submit-type="export"
        @search="handleSearch"
      />
    </div>
  </div>
</template>

<script>
import { apiPoint } from '../../api/point/point.js'
import FilterFrame from '../../components/FilterFrame'
export default {
  components: {
    FilterFrame
  },
  data () {
    return {
      filterForm: [
        {
          label: this.$t('ReportView.Month'),
          name: 'month',
          type: 'month'
        }
      ]
    }
  },
  methods: {
    handleSearch (val) {
      const date = val.month
      if (date) {
        const year = date.substring(0, 4)
        const month = date.substring(4)
        this.getExcel(year, month)
      } else {
        this.$message.warning(this.$t('ReportView.PleaseSelectDate'))
      }
    },
    async getExcel (year, month) {
      try {
        const { data } = await apiPoint.getExcel(year, month)
        const communityName = JSON.parse(localStorage.getItem('loginUserInfo')).CommunityName
        this.$downloadFile(data, `${communityName}_${year}${month}_${this.$t('ReportView.ProductReport')}.xlsx`)
      } catch (error) {
        // 後端有給錯誤提示，沒給則統一給籠統的「請稍後再試」
        console.log(error)
        this.$message.error(this.$t('ReportView.ExportFailed'))
      }
    }
  }
}
</script>

<style lang="scss">
#point_report {
  @include mainLayer();
}
</style>
